import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDown1 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.75 8.5C5.33578 8.5 5 8.83579 5 9.25L5.00002 18.25C5.00002 18.6642 5.33581 19 5.75002 19L14.75 19C15.1642 19 15.5 18.6642 15.5 18.25C15.5 17.8358 15.1642 17.5 14.75 17.5L7.56068 17.5L17.7803 7.28033C18.0732 6.98744 18.0732 6.51256 17.7803 6.21967C17.4874 5.92678 17.0126 5.92678 16.7197 6.21967L6.50002 16.4393L6.5 9.25C6.5 8.83579 6.16421 8.5 5.75 8.5Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgArrowDown1;
